/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
// @ts-ignore
import React from 'react'

import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'

import Loading from '../loading'
import Icon from '../icon'

import { Container, LinkToGoogleMaps } from './styles'

import IProps from './props'

import { settings } from '../../../main/configs/settings'
import LinkBuilder from '../../helpers/helper-link-builder'

const containerStyle = {
  width: '100%',
  height: '100%',
  borderRadius: '16px',
}

const Map = ({ location }: IProps) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: settings.GOOGLE_API_KEY as string,
  })

  return (
    <Container>
      {isLoaded && location ? (
        <>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={location}
            zoom={18}
          >
            <Marker position={location} />
          </GoogleMap>
          <LinkToGoogleMaps
            to={{
              pathname: LinkBuilder.buildGoogleMapsLink(
                location.lat,
                location.lng,
              ),
            }}
            target="_blank"
          >
            Abrir no Google Maps
            <Icon name="arrow-right-second" />
          </LinkToGoogleMaps>
        </>
      ) : (
        <Loading />
      )}
    </Container>
  )
}

export default Map
